/**
 * JeriCommerce Pass API · staging
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 202610.20.01
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RegisterField } from './register-field';
import { ProgramConfig } from './program-config';


export interface Program { 
    id: string;
    name: string;
    parentId: string;
    slug: string;
    integration: Program.IntegrationEnum;
    contactEmail: string;
    consentOptInUrl: string;
    balanceNotifications: boolean;
    balanceNotificationsMessage: string;
    tierNotifications: boolean;
    tierNotificationsMessage: string;
    rewardAvailableNotifications: boolean;
    rewardAvailableNotificationsMessage: string;
    locationNotifications: boolean;
    marketingNotifications: boolean;
    configurations: ProgramConfig;
    downloadEmail: boolean;
    verifyEmail: boolean;
    redeemRewardEmail: boolean;
    couponAssignedEmail: boolean;
    rewardRedeemableEmail: boolean;
    defaultLanguage: string;
    enabledLanguages: Array<string>;
    nfcEnabled: boolean;
    barcodeFormat: Program.BarcodeFormatEnum;
    registerFields: Array<RegisterField>;
    notificationsPriority: Array<Program.NotificationsPriorityEnum>;
    consolidatePushesWithAi: boolean;
    currency: string;
    shopifyCustomerAccountsVersion: Program.ShopifyCustomerAccountsVersionEnum | null;
    shopifyInstalledChannels: Array<string> | null;
    /**
     * Whether the Shopify shop is on Shopify Plus. Null until first read from Shopify.
     */
    shopifyPlus: boolean | null;
    /**
     * Shopify plan display name (e.g. \"Shopify Plus\", \"Developer Preview\").
     */
    shopifyPlanName: string | null;
    shouldShowPaymentModal: boolean;
    partner: string;
    createdAt: string;
    updatedAt: string;
}
export namespace Program {
    export type IntegrationEnum = 'api' | 'convercus' | 'jericommerce' | 'klaviyo' | 'shopify/loyalty-lion' | 'mcp' | 'shopify' | 'vtap' | 'idtech';
    export const IntegrationEnum = {
        Api: 'api' as IntegrationEnum,
        Convercus: 'convercus' as IntegrationEnum,
        Jericommerce: 'jericommerce' as IntegrationEnum,
        Klaviyo: 'klaviyo' as IntegrationEnum,
        ShopifyLoyaltyLion: 'shopify/loyalty-lion' as IntegrationEnum,
        Mcp: 'mcp' as IntegrationEnum,
        Shopify: 'shopify' as IntegrationEnum,
        Vtap: 'vtap' as IntegrationEnum,
        Idtech: 'idtech' as IntegrationEnum
    };
    export type BarcodeFormatEnum = 'qr' | 'barcode';
    export const BarcodeFormatEnum = {
        Qr: 'qr' as BarcodeFormatEnum,
        Barcode: 'barcode' as BarcodeFormatEnum
    };
    export type NotificationsPriorityEnum = 0 | 1 | 2 | 3;
    export const NotificationsPriorityEnum = {
        NUMBER_0: 0 as NotificationsPriorityEnum,
        NUMBER_1: 1 as NotificationsPriorityEnum,
        NUMBER_2: 2 as NotificationsPriorityEnum,
        NUMBER_3: 3 as NotificationsPriorityEnum
    };
    export type ShopifyCustomerAccountsVersionEnum = 'CLASSIC' | 'NEW_CUSTOMER_ACCOUNTS';
    export const ShopifyCustomerAccountsVersionEnum = {
        Classic: 'CLASSIC' as ShopifyCustomerAccountsVersionEnum,
        NewCustomerAccounts: 'NEW_CUSTOMER_ACCOUNTS' as ShopifyCustomerAccountsVersionEnum
    };
}


